import React from 'react';
import styles from './ActionBarWrapper.css';

class ActionBarWrapper extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={`row ${styles['row-wrapper']}`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ActionBarWrapper;
